import 'javascripts/jquery-ui/dialog'
import { autogrow } from 'javascripts/general_scripts'

/* stylesheet */
import 'stylesheets/inappropriate.less'
import 'jquery-ui/themes/base/dialog'
import 'jquery-ui/themes/base/button'
import 'jquery-ui/themes/base/resizable'

autogrow();

const ipf = $('#inappropriate-item-form');
var ipf_modal = ipf.dialog({
  dialogClass: "gitb-modal inappropriate-form",
  disabled: true,
  width: 450,
  modal: true,
  autoOpen: false,
  closeText: 'hide',
  open(event, ui) {
    $('.ui-widget-overlay').on('click', () => ipf_modal.dialog('close'));
  },
  close() {
    ipf.find('form').trigger('reset')
  }
});

$(document).on('click', '.open-inappropriate-link', function() {
  ipf.find('#item_id').val($(this).data('item_id'));
  ipf.find('#item_type').val($(this).data('item_type'));
  ipf_modal.dialog('open');
  return false;
});

// Close form when submitted
ipf.on('ajax:complete', function(event, data) {
  ipf_modal.dialog('close');
  const response = JSON.parse(data.responseText);
  return alert(response.message);
});